// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-container[data-v-f104fb20]{max-width:100%!important;padding:0!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
